module.exports = __webpack_public_path__ + "static/assets/960e47690012d111fa474174ebd97231.svg";